module.exports = __webpack_public_path__ + "static/media/dwt-08.cf4c21f4.jpg";